/**
 * v1.3 Wave 2 — a single drafted (never-yet-sent) in-app notification,
 * shown for review before a plan is approved. Purely presentational —
 * this component never sends anything itself.
 */
export const DraftMessagePreview = ({ message }) => {
  if (!message) return null;
  return (
    <div className="mt-2 rounded-lg border bg-background/40 p-2" data-testid="ai-action-plan-draft-message-preview">
      <p className="text-xs font-medium text-foreground">
        To: <span className="text-muted-foreground font-normal">{message.recipient_name}</span>
      </p>
      {message.title && <p className="mt-0.5 text-xs font-semibold text-foreground">{message.title}</p>}
      <p className="mt-1 text-xs leading-5 text-muted-foreground line-clamp-2">{message.body}</p>
    </div>
  );
};
